<template>
  <el-dialog
    title="收款详情"
    :visible="visible"
    width="800px" :destroy-on-close="true" :before-close="close">
    <QS-common-table
      :data="tableData"
      :columns="tableColumns"
      row-key="id"
      :pagination="paginationData"
      @change="paginationChange"
      v-loading="tableLoading"
    />
  </el-dialog>
</template>
<script>
import { receivepaymentDetailConf } from './driversbillConfig.js'
import { orderReceivableInfo } from '@/api/domain/orders'

export default {
  data() {
    const { tableColumns } = receivepaymentDetailConf.call(this)
    return {
      visible: false,
      tableData: [],
      tableColumns,
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      tableLoading: false,
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    open(orderId, receivableIds) {
      this.visible = true
      this.orderId = orderId
      this.receivableIds = receivableIds
      this.getOrderReceivableInfo()
    },
    close() {
      this.visible = false
      this.orderId = ''
      this.receivableIds = ''
    },
    paginationChange(payload) {
      const {
        pagination: { pageSize, pageNum },
      } = payload
      this.paginationData.pageSize = pageSize
      this.paginationData.pageNum = pageNum
      this.getOrderReceivableInfo()
    },
    async getOrderReceivableInfo() {
      const { code, data } = await orderReceivableInfo({
        orderId: this.orderId,
        receivableIds: this.receivableIds,
        pageSize: this.paginationData.pageSize,
        pageNum: this.paginationData.pageNum,
      })
      if (code === 1) {
        this.tableData = data?.items || []
        this.paginationData.total = data?.totalNum || 0
      }
    },
  },
}
</script>
